/**
 * This file defines the available languages and their configurations
 * for use with i18next and react-native-localize
 */

const ExistLanguages = {
  en: {
    id: 0,
    languageCode: 'en',
    countryCode: 'US',
    language: 'English (US)',
    isRTL: false,
    loader: () => require('../assets/i18n/en.json'),
    translationNamespace: 'translation',
  },
  ar: {
    id: 1,
    languageCode: 'ar',
    countryCode: 'SA',
    language: 'العربية',
    isRTL: true,
    loader: () => require('../assets/i18n/ar.json'),
    translationNamespace: 'translation',
  },
};

// Type for supported language codes
type SupportedLanguage = keyof typeof ExistLanguages;

export const getLanguageResources = () => {
  const resources: Record<string, {translation: any}> = {};

  Object.keys(ExistLanguages).forEach(lang => {
    const langKey = lang as SupportedLanguage;
    resources[lang] = {
      translation: ExistLanguages[langKey].loader(),
    };
  });

  return resources;
};

export default ExistLanguages;
